import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DetailWrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media screen and (max-width: 991px) {
    flex-direction: column;
  }
`;

export const DetailSection = styled.section`
  display: flex;
  flex-direction: column;
  width: 65%;
  padding: 30px 50px 30px 0px;
  word-break: break-all;
  @media screen and (max-width: 991px) {
    width: 100%;
    padding: 16px 10px;
  }
`;

export const StickySection = styled.form`
  position: sticky;
  top: 74px;
  display: flex;
  flex-direction: column;
  width: 35%;
  height: ${(props) =>
    props.$scroll ? "calc(100vh - 73px)" : "calc(100vh - 305px)"};
  padding: 16px 10px;

  @media screen and (max-width: 991px) {
    width: 100%;
    position: relative;
    height: auto;
    top: 0%;
    border-top: 2px solid #ececec;
  }
`;

export const StickyHeader = styled.div`
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & h4 {
    margin-bottom: 24px;
  }

  & i {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2px;
    margin-right: 3px;
  }
`;

export const StickyBody = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  margin-bottom: 1rem;
  padding-right: 10px;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  border: 1px solid #ececec;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  border-bottom: 1px solid #ececec;
  padding: 10px 5px;
  :last-of-type {
    border-bottom: none;
  }
`;

export const StickyFooter = styled.div`
  display: flex;

  .confirm {
    width: 100%;
  }
`;

export const GuestWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const TimerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;

  & h6 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  & span {
    font-size: 1rem;
    color: #253d4e;
  }
`;
